import { useAppUser, useMemberClan } from 'components/_hooks'
import React from 'react'
import { UserUtils } from 'server/utils/user-utils'
import { OperationTypes, useCancel } from 'store/logic/operations-logic'
import { getClanProfileUrl } from 'store/types/clan-types'
import { getIsAdmin, getIsOrganizer, getIsPlayer } from 'store/types/user-types'
import VerticalHeaderItem from './VerticalHeaderItem'

import styles from '../Header.module.scss'
import { cn } from 'utils'

const ProfileDropDown = () => {
  const cancelLoadAppUser = useCancel(OperationTypes.loadAppUser, null)
  const user = useAppUser()
  const { clan } = useMemberClan(user?.Id)

  const isUserLoggedIn = !!user
  const isOrganizer = getIsOrganizer(user?.Role)
  const isPlayer = getIsPlayer(user?.Role)
  const isAdmin = getIsAdmin(user?.Role)

  const handleLogoutClick = async () => {
    await UserUtils.LogoutUser()
    cancelLoadAppUser()
    window.location.href = '/'
  }

  return (
    <div className={cn(styles.header__profileDropdown, styles.profileDropdown)}>
      <div className="row m-0 flex-column">
        {!isUserLoggedIn ? (
          <>
            <VerticalHeaderItem text="Login" to="/login" icon={styles.profileDropdown__icon__account} />
            <VerticalHeaderItem text="Sign up" to="/register" icon={styles.profileDropdown__icon__logout} />
          </>
        ) : (
          <>
            {isOrganizer && (
              <>
                <VerticalHeaderItem
                  text="Create tourney"
                  to="/create-tournament/"
                  icon={styles.profileDropdown__icon__accountOrganizer}
                />
                <VerticalHeaderItem text="My Account" to="/my-profile" icon={styles.profileDropdown__icon__account} />
                <VerticalHeaderItem text="My Events" to="/events/upcoming" icon={styles.profileDropdown__icon__events} />
                <VerticalHeaderItem text="transactions-all" to="/transactions-all" icon={styles.profileDropdown__icon__transactions} />
                <VerticalHeaderItem text="Billing Options" to="/billing-option-organizer" icon={styles.profileDropdown__icon__buySell} />
                {/* <VerticalHeaderItem
                                    text="My Message Board"
                                    to="/message-board"
                                    icon="profile-dropdown__icon--messages"
                                  /> */}
                <VerticalHeaderItem text="Scan page" to="/qr-scanner" icon={styles.profileDropdown__icon__scan} />
                <VerticalHeaderItem text="Members" to="/members/players" icon={styles.profileDropdown__icon__clan} />
                <VerticalHeaderItem text="Disputes" to="/disputes" icon={styles.profileDropdown__icon__disputes} />
              </>
            )}
            {isPlayer && (
              <>
                <VerticalHeaderItem text="My Account" to="/player" icon={styles.profileDropdown__icon__account} />
                <VerticalHeaderItem text="My Battles" to="/battles/checkin" icon={styles.profileDropdown__icon__battles} />
                <VerticalHeaderItem text="My Events" to="/events/live" icon={styles.profileDropdown__icon__events} />
                { clan && <VerticalHeaderItem text="My Clan" to={getClanProfileUrl(clan?.Id)} icon={styles.profileDropdown__icon__clan} /> }
                <VerticalHeaderItem text="Transactions" to="/player-transactions" icon={styles.profileDropdown__icon__transactions} />
                <VerticalHeaderItem
                  text="Directory"
                  to="/members/players"
                  icon={styles.profileDropdown__icon__directory}
                />
                {/* <VerticalHeaderItem
                                    text="Message Board"
                                    to="/message-board"
                                    icon="profile-dropdown__icon--messages"
                                  /> */}
                <VerticalHeaderItem text="Cart" to="/cart" icon={styles.profileDropdown__icon__cart} />
              </>
            )}
            {isAdmin && (
              <>
                <VerticalHeaderItem text="Members" to="/members/players" icon={styles.profileDropdown__icon__clan} />
                <VerticalHeaderItem text="Scan page" to="/qr-scanner" icon={styles.profileDropdown__icon__scan} />
              </>
            )}
            <VerticalHeaderItem text="Log out" to="/" onClick={handleLogoutClick} icon={styles.profileDropdown__icon__logout} />
          </>
        )}
      </div>
    </div>
                    
  )
}

export default ProfileDropDown
